
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { tryMultipleAssetPaths } from "@/utils/assetUtils";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [logoPath, setLogoPath] = useState("");
  
  useEffect(() => {
    tryMultipleAssetPaths("disco_logo_v2.png", (path) => {
      if (path) {
        console.log("✅ Successfully loaded logo path in AuthLayout:", path);
        setLogoPath(path);
      } else {
        console.error("Failed to find working logo path in AuthLayout");
      }
    });
  }, []);
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-black p-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <Link to="/" className="text-white flex items-center">
            {!logoLoaded && logoPath === "" && <span className="font-bold text-xl">DISCO</span>}
            {logoPath && (
              <img 
                src={logoPath} 
                alt="Disco Logo" 
                className="h-10"
                onLoad={() => setLogoLoaded(true)}
                onError={() => {
                  console.error("Failed to load logo in AuthLayout");
                }}
              />
            )}
          </Link>
          <Link 
            to="/login" 
            className="text-white flex items-center gap-1 text-sm hover:opacity-80 transition-opacity"
          >
            <LogIn size={16} />
            Log in
          </Link>
        </div>
      </header>

      <main className="flex-grow flex items-center justify-center py-12 px-4">
        {children}
      </main>

      <footer className="bg-black text-white py-3 px-4 text-xs">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <div>©2025 Disco. All Rights Reserved</div>
          <div className="flex gap-3">
            <a 
              href="https://www.discoveryconciergeservices.com/terms-conditions" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Terms & Conditions
            </a>
            <span>|</span>
            <a 
              href="https://www.discoveryconciergeservices.com/privacy-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};
